import React, { MouseEventHandler, useRef } from 'react';
import { CSSProperties } from 'react';
import { ModalBox } from './Modal.style';

type IProps = {
  title?: string,
  children?: React.ReactNode
  handleClick?(): void
  onClick?: MouseEventHandler
  close?(): void
  disabledModalClick?: boolean
  disableHead?: boolean
  disabledBorder?: boolean
  style?: CSSProperties
  titleStyle?: CSSProperties
  containerStyle?: CSSProperties
  contentStyle?: CSSProperties
  fullScreen?: boolean
  isH5?: boolean
  active?: boolean
  enableBodyScroll?: boolean
}
export default function Modal(props: IProps) {
  const mouseDownTarget = useRef<EventTarget | null>(null);

  function handleClick(event: React.MouseEvent) {
    if (!props.disabledModalClick) {
      // @ts-ignore
      let targetId = event.target.id;
      if (!props.isH5 && mouseDownTarget.current === event.currentTarget && typeof  props.close === "function") {
        props.close();
      }
    }
  }

  return (
    <ModalBox
      id={"modal"}
      onMouseDown={(event) => {
        mouseDownTarget.current = event.target;
      }}
      onClick={handleClick}>
      <div className={`modal_content_box`}
           style={props.style}
           onClick={(event) => {
             // event.stopPropagation();
             // @ts-ignore
             props.onClick && props.onClick(event);
           }}>
        <h1 className="modal-title">
          <span>{props.title}</span>
          {/*<div className="close" onClick={props.close}>
            <img src={require("src/assets/images/close.png")} className={"closeIcon"} alt="" />
          </div>*/}
        </h1>
        <div className={"modal_content"} id={"modal_content"} style={props.contentStyle}>
          {props.children}
        </div>
      </div>
    </ModalBox>
  )
}
